import { render, staticRenderFns } from "./handpickGroupAdd.vue?vue&type=template&id=db3a71d0&scoped=true&"
import script from "./handpickGroupAdd.vue?vue&type=script&lang=js&"
export * from "./handpickGroupAdd.vue?vue&type=script&lang=js&"
import style0 from "./handpickGroupAdd.vue?vue&type=style&index=0&id=db3a71d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3a71d0",
  null
  
)

export default component.exports